module.exports = __webpack_public_path__ + "static/media/line-chart_blue.fab77ff7.svg";